import { AlpineComponent } from '@alpinejs/csp';
import { calculatePercentage } from '../../javascripts/helpers/maths';

const SuccessStoryTeaser = (): AlpineComponent => ({
  count: 0,
  index: 0,
  animate: false,
  hovered: false,
  lottie: undefined,
  init() {
    this.count = Number(this.$root.dataset.count);

    (async () => {
      const { default: Lottie } = await import('lottie-web');

      this.lottie = Lottie.loadAnimation({
        container: this.$refs.animation,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path:
          this.count === 1
            ? '/dist/assets/animations/teaser-frame-one-success-story.json'
            : '/dist/assets/animations/teaser-frame-success-story.json'
      });
    })();
  },
  handleScroll() {
    if (window.innerWidth >= 768) return;

    const scrollTop = window.scrollY;

    const { top, bottom } = this.$root.getBoundingClientRect();
    const start = top + scrollTop;
    const end = bottom + scrollTop;
    const current = scrollTop + window.innerHeight / 2;
    const percentage = calculatePercentage(current, start, end);

    this.index = Math.floor(percentage * this.count);
  },

  handleScrollTo() {
    const i = Number(this.$el.dataset.index);
    const { scrollHeight } = this.$root;
    const { top } = this.$root.getBoundingClientRect();
    const realTop = top + window.scrollY;
    const scrollTo = (scrollHeight / this.count) * i;

    window.scrollTo({ top: realTop + scrollTo, behavior: 'smooth' });
  },

  getClassName() {
    return {
      'success-story-teaser--animate': this.animate,
      'success-story-teaser--hovered': this.hovered
    };
  },

  handleIntersect() {
    const i = Number(this.$el.dataset.index);
    if (window.innerWidth < 768) return;

    this.index = i;
    this.hovered = false;

    if (this.lottie) {
      this.lottie.play();
      this.lottie.setDirection(this.lottie.playDirection * -1);
    }
  },
  isActive() {
    return this.index === Number(this.$el.dataset.index);
  },
  isCurrent() {
    return this.index === Number(this.$el.dataset.index) ? 'true' : 'false';
  },
  handleMouseEnter() {
    this.hovered = true;
  },
  handleMouseLeave() {
    this.hovered = false;
  }
});

export default SuccessStoryTeaser;
